import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import ExpenseCategoriesForm from '../Layouts/ExpenseCategoriesForm';
import { ExpenseCategoriesFormValues } from 'src/models/ExpenseCategories.model';
import { useAddExpenseCategoryMutation } from 'src/services/ExpenseCategoryServices';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddExpenseCategoriesFormWrapper = ({ onClose }: Props) => {
  const [addExpenseCategory] = useAddExpenseCategoryMutation()
  // Form Initial Values
  const initialValues: ExpenseCategoriesFormValues = {
    categoryName:""
  };

  // Validation Schema
  const validationSchema = object().shape({
    categoryName:string().required("Please enter category name")
  });

  // Handle Submit
  const handleSubmit = (
    values: ExpenseCategoriesFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ExpenseCategoriesFormValues>
  ) => {
    addExpenseCategory(values).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast('error', res?.data?.message);
        }
      }
      setSubmitting(false);
    })
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ExpenseCategoriesForm formikProps={formikProps} onClose={onClose} formType="Add" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddExpenseCategoriesFormWrapper;